import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "fileType-word",
  "use": "fileType-word-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"fileType-word\"><defs><symbol id=\"fileType-word_a\" data-name=\"file-word\" viewBox=\"0 0 20 20\"><path d=\"M15.77 0H0v20h20V4.23zm-3.5 13.57h-1.1L9.8 8.35l-1.41 5.22H7.28L5.34 6.81H6.5l1.32 5.27 1.42-5.27h1.08l1.38 5.27 1.32-5.27h1.17zm3.5-9.2V.28l4.08 4.08z\" fill=\"#4471bc\" /></symbol></defs><title>fileType-word</title><g data-name=\"图层 2\"><use width=\"20\" height=\"20\" xlink:href=\"#fileType-word_a\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/fileType-word.svg
// module id = nlge
// module chunks = 6